import { Inject, Options, Vue } from "vue-property-decorator";
import { AppInsights } from "@/trust-admin-app/appInsights";
import { TrustAPI } from "@/shared/modules/trust-api";
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import { EventEmitter } from "events";
import store from "@/trust-admin-app/store";
import ErrorIndicator from "@/shared/components/error-indicator/error-indicator";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import { orderBy } from "lodash";
import { PracticeView } from "@/shared/modules/typescript-trustapi-client/models";

@Options({
  components: {
    LoadingIndicator,
    ErrorIndicator,
  },
  mixins: [FormatDateTimeMixin]
})
export default class PracticePeopleSolicitors extends Vue {
  private ai = new AppInsights;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }


  private searchKeyword = '';
  private showActiveOnly = true;

  private sortMethod = 'desc';
  private activeSortHeader = 0;

  private solicitors: any = [];
  private solicitorsDisplay: any = [];

  private loadingContent = false;
  private errorLoadingContent = false;
  private loadingDataSet = false;
  private errorLoadingDataSet = false;


  private tableHeadings = [
    { text: 'LawID', value: 'indId', sortable: true, sortMethod: 'acs' },
    { text: 'Name', value: 'name', sortable: true, sortMethod: 'acs' },
    { text: 'Phone number', value: 'phone', sortable: true, sortMethod: 'acs' },
    { text: 'Email', value: 'email', sortable: true, sortMethod: 'acs' },
    { text: 'From', value: 'effectiveStartDate', sortable: true, sortMethod: 'asc' },
    { text: 'To', value: 'effectiveEndDate', sortable: true, sortMethod: 'acs' },
    { text: 'Employment classification', value: 'empClassificationShortDescription', sortable: true, sortMethod: 'acs' },
  ];

  mounted() {
    this.loadTableData();
  }

  private loadTableData() {
    this.loadingContent = true;
    this.apiService.PeopleApi?.apiV2PeopleGetIndividualsByPracticeIdPracticeIdGet(
      this.selectedPractice.id, '', false
    )
      .then(res => {
        this.solicitors = res.data.data;
        this.solicitorsDisplay = this.solicitors;
        for (let i = 0; i < this.solicitors.length; i++) {
          this.solicitorsDisplay[i].name = this.solicitors[i].firstName + ' ' + this.solicitors[i].lastName;
        }
        this.$emit('loadStatData');
        this.sortTableColumn(0, true);
        this.loadingContent = false;
      })
      .catch(err => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to get solicitors list');
        this.ai.trackException('Error getting investigations: ' + err);
        this.loadingContent = false;
        this.errorLoadingContent = true;
      })

  }

  private sortTableColumn(index: number, sortable: boolean) {
    if (sortable) {
      if (this.tableHeadings[index].sortable) {
        this.activeSortHeader = index;
        this.sortMethod = this.sortMethod === 'desc' ? 'asc' : 'desc';
        this.tableHeadings[index].sortMethod = this.sortMethod;
        if (this.solicitors.length > 0) {
          const nameSorter = index == 1 ? (c: any) => c.name.toLowerCase() : [this.tableHeadings[index].value, (c: any) => c.name.toLowerCase()];
          const orderByResults = orderBy(
            this.solicitors,
            nameSorter,
            [this.sortMethod as any]
          );
          this.solicitorsDisplay = orderByResults;
        }
      }
    }
  }

  private applyFilter(data: any) {
    if (this.searchKeyword == '') return data;
    const _result = data.filter((d: any) => {
      return d.name.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) >= 0
        || d.indId.toString().indexOf(this.searchKeyword.toLowerCase()) >= 0;
    })
    return _result;
  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }
}

